import React from 'react'
import { Container } from 'react-bootstrap'
import SectionHeader from './SectionHeader'
import { Link } from 'react-router-dom';

const FormLinks = () => {
    const page = [
        { label: 'personal' },
        { label: 'professional' },
        { label: 'sports' },
        { label: 'vendor' },
    ];
    return (
        <>
            <section>
                <SectionHeader title="Events Links"></SectionHeader>
                <div className="in-page-container pb-5">
                    <div className="about-section top__about">
                        <Container>
                            <div className="form-links pad__150">
                                {page.map((lang, index) => (
                                    <div className="links__item">
                                        <Link to={"/form/" + lang.label} key={index} className='nav_link'>{lang.label}</Link>
                                    </div>
                                ))}
                            </div>
                        </Container>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FormLinks